class LoginPopup extends HTMLElement {
  constructor() {
    super()

    this.loginEl = this.querySelector('[data-login-form]')
    this.forgotPasswordEl = this.querySelector('[data-forgot-password-form]')
    this.toggleButtons = this.querySelectorAll('[data-toggle-button]')
    this.socialButtons = this.querySelectorAll('[data-social-button]')
    this.closebuttons = this.querySelectorAll('[data-login-popup-close]')
    this.openButtons = document.querySelectorAll('[data-open-login-popup]')

    this.initialize()
  }

  waitForLR () {
    LRObject.util.ready(() => {
      this.initialize()
    })
  }

  initialize () {
    // Optional chaining is not valid on the left-hand side of an assignment
    // (`a?.b = c` is a SyntaxError that voids the entire file, which left the
    // login popup — and the "sign in to use saved prescription" button — dead
    // in every locale). Guard the global explicitly instead.
    if (typeof login_options !== 'undefined' && login_options) login_options.popup = true
    this.initSocialButtons()
    this.initToggleButtons()
    this.initCloseButtons()
    this.initOpenButtons()

    window.addEventListener('login', () => {
      this.close()
      this.openButtons.forEach(openButton => {
        openButton.classList.add('hidden')
      })
    })
  }

  open () {
    this.classList.add('active')
  }

  initOpenButtons () {
    this.openButtons.forEach(openButton => {
      openButton.addEventListener('click', () => { this.open() })
    })
  }

  close () {
    this.classList.remove('active')
  }

  initCloseButtons () {
    this.closebuttons.forEach(closeButton => {
      closeButton.addEventListener('click', () => { this.close() })
    });
  }

  initToggleButtons() {
    this.toggleButtons.forEach(toggleButton => {
      toggleButton.addEventListener('click', () => {
        const type = toggleButton.dataset.type
        this.toggleForm(type)
      })
    })
  }

  toggleForm (type) {
    this.loginEl.classList.toggle('hidden', type === 'forgot')
    this.forgotPasswordEl.classList.toggle('hidden', type === 'login')
  }

  initSocialButtons () {
    this.socialButtons.forEach(socialButton => {
      socialButton.addEventListener('click', () => {
        const provider = socialButton.dataset.provider
        this.socialLogin(provider)
      })
    })
  }

  socialLogin (provider) {
    const realButton = this.querySelector(`[data-label-short="${provider}"]`)
    realButton && realButton.click()
  }
}

customElements.define('login-popup', LoginPopup)